const createEvents = (module, events) =>
  Object.fromEntries(events.map((event) => [event.toUpperCase(), { event_name: event, module }]));

// Auth module events
export const AUTH_EVENTS = createEvents('auth', [
  'signup_started',
  'signup_completed',
  'email_verified',
  'login_started',
  'login_successful',
  'logout_successful',
]);

// Onboarding module events
export const ONBOARDING_EVENTS = createEvents('onboarding', [
  'personalization_started',
  'role_selected',
  'use_case_selected',
  'feature_selected',
  'hear_about_selected',
  'notification_opt_in',
  'personalization_skip',
  'personalization_next',
  'demo_started',
  'demo_video_played',
  'demo_next',
  'payment_processing_viewed',
  'payment_plan_selected',

  'payment_skipped',
]);

// Dashboard module events
export const DASHBOARD_EVENTS = createEvents('dashboard', [
  'dashboard_viewed',
  'video_tutorial_played',
  'tutorial_dismissed',
  'create_menu_opened',
  'dynamic_survey_creation_start',
  'dynamic_survey_upload_start',
  'interview_creation_start',
  'interview_upload_start',
  'ai_participant_creation_start',
]);

// Sidebar module events
export const SIDEBAR_EVENTS = createEvents('sidebar', [
  'sidebar_dashboard_clicked',
  'sidebar_surveys_clicked',
  'sidebar_interviews_clicked',
  'sidebar_ai_participants_clicked',
  'sidebar_tutorials_clicked',
  'sidebar_user_guide_clicked',
  'sidebar_help_clicked',
]);

// Tutorial and Demos module events
export const TUTORIAL_EVENTS = createEvents('tutorial_and_demos', [
  'tutorial_page_viewed',
  'video_played',
  'help_support_clicked',
]);

// Dynamic Surveys Events
export const DYNAMIC_SURVEY_EVENTS = createEvents('dynamic_surveys', [
  'viewed_survey_objectives_modal',
  'clicked_survey_objectives_continue',
  'clicked_survey_objectives_cancel',
  'clicked_survey_create_manually',
  'clicked_survey_create_AI',
  'viewed_AI_generate_modal',
  'clicked_survey_AI_generate',
  'viewed_survey_editor_manual',
  'viewed_survey_editor_AI',
  'clicked_survey_save_and_continue_1',
  'viewed_survey_configure_screen',
  'toggled_survey_participant_concent',
  'toggled_survey_participant_email',
  'toggled_survey_optional_signup',
  'entered_survey_redirect_url',
  'selected_survey_enddate',
  'clicked_survey_generate_welcome_message',
  'clicked_survey_preview',
  'clicked_survey_save_and_continue_2',
  'viewed_survey_share_screen',
  'clicked_copy_survey_link',
  'clicked_download_survey_qrcode',
  'clicked_survey_send_to_AI_participants',
  'clicked_survey_share_screen_dashboard',
]);

export const DYNAMIC_SURVEY_UPLOAD_EVENTS = createEvents('dynamic_survey_upload', [
  'viewed_surveyupload_screen',
  'surveyupload_download_template',
  'clicked_surveyupload_back',
  'viewed_surveyupload_previewscreen',
  'clicked_surveyupload_cancel',
  'clicked_surveyupload__save_and_analyze',
  'surveyupload_exit',
]);

export const INTERVIEW_EVENTS = createEvents('interview', [
  'viewed_interview_create_screen',

  'generate_interview_research_question_ai',
  'generate_interview_guideline_ai',
  'interview_type',
  'interview_time_limit',
  'clicked_interview_save_and_continue_1',
  'viewed_interview_configure_screen',
  'toggled_interview_participant_concent',
  'toggled_interview_participant_email',
  'toggled_interview_participant_accesscode',
  'toggled_interview_voice_to_voice_mode',
  'toggled_survey_optional_signup',
  'entered_redirect_url',
  'selected_interview_enddate',
  'clicked_generate_ai_welcome_message',
  'clicked_interview_save_and__continue_2',
  'viewed_interview_share_screen',
  'clicked_copy_interview_link',
  'clicked_download_interview_qrcode',
  'clicked_interview_send_to_AI_participants',
  'clicked_interview_share_screen_dashboard',
]);

// Interview Upload Events
export const INTERVIEW_UPLOAD_EVENTS = createEvents('interview_upload', [
  'interview_upload_creation_started',

  'interview_upload_details_submitted',
  'interview_viewed_upload_screen',
  'upload_download_template',
  'clicked_interview_upload_back',
  'viewed_upload_previewscreen',
  'clicked_interview_upload_cancel',
  'clicked_interview_upload_continue',
  'upload_exit',
  'clicked_interview_upload_estimation_agree',

  'interview_file_upload_started',
  'interview_file_upload_completed',
  'interview_file_upload_failed',
  'interview_text_file_uploaded',
  'interview_audio_file_uploaded',
  'interview_video_file_uploaded',

  'interview_language_selected',
  'interview_file_added',
  'interview_estimation_dialog_opened',
]);

export const PAYMENT_UPGRADE_EVENTS = createEvents('payment_upgrade', [
  'viewed_payment_upgrade_modal',
  'payment_plan_selected_modal',
  'closed_payment_plan_modal',
]);

export const CREDITS_PURCHASED_EVENTS = createEvents('creditspurchased', [
  'viewed_credits_purchase_modal',
  'credits_balance_update_attempted',
  'credits_balance_update_success',
  'credits_purchase_success',
  'credits_purchase_modal_closed',
]);

export const CREDITS_USED_EVENTS = createEvents('creditsused', [
  'credits_used_interview_upload',
  'credits_used_dynamic_survey_upload',
  'credits_used_ai_interview_response',
  'credits_used_ai_dynamic_survey_response',
  'credits_used_analysis_lens',
  'credits_used_transcription',
  'credits_used_survey_analysis',
  'credits_used_reanalysis',
  'credits_used_code_generation',
  'credits_used_theme_generation',
]);

export const ANALYSIS_LENS_EVENTS = createEvents('analysis_lens', [
  'lens_page_viewed',
  'lens_selected',
  'lens_run_started',
  'lens_run_completed',
  'lens_run_failed',
  'transcript_selection_changed',
  'lens_results_viewed',
]);

export const ANALYSIS_GROUNDED_EMERGENCE_EVENTS = createEvents('analysis_grounded_emergence', [
  'grounded_emergence_tab_selected',
  'grounded_emergence_run_started',
  'grounded_emergence_run_completed',
  'grounded_emergence_run_failed',
]);

export const CHAT_WITH_ANALYSIS_EVENTS = createEvents('chat_with_analysis', [
  'viewed_chat_with_analysis',
  'user_sent_message',
  'ai_responded',
]);
export const CREDITS_ESTIMATION_EVENTS = createEvents('credits_estimation', [
  'credits_estimation_started',
  'credits_estimation_completed',
  'credits_estimation_failed',
  'credits_insufficient',
  'credits_check_initiated',
  'credits_purchase_prompted',
]);

export const DYNAMIC_SURVEY_DETAILS_EVENTS = createEvents('dynamic_survey_details', [
  'survey_details_viewed',
  'response_insights_tab_clicked',
  'participant_data_tab_clicked',
  'question_analysis_tab_clicked',
  'report_tab_clicked',
  'custom_reports_tab_clicked',
]);

export const DYNAMIC_SURVEY_DETAILS_QUESTION_ANALYSIS_EVENTS = createEvents(
  'dynamic_survey_details_question_analysis',
  [
    'responses_tab_clicked',
    'responses_text_search_clicked',
    'responses_semantic_search_clicked',
    'responses_code_search_clicked',

    'open_codes_tab_clicked',
    'sentiment_analysis_tab_clicked',
    'thematic_analysis_tab_clicked',
    'shanky_chart_tab_clicked',
    'refresh_button_clicked',
    'update_themes_button_clicked',
  ],
);

export const CODE_DETAILS_DYNAMIC_SURVEY_EVENTS = createEvents('code_details_dynamic_survey', [
  'code_details_viewed',
  'code_details_updated',
  'code_details_deleted',
  'code_details_modal_closed',
  'add_assign_code_modal_opened',
  'selected_existing_code',
  'new_code_save_and_assign_clicked',
]);

export const DYNAMIC_SURVEY_DETAILS_THEME_EVENTS = createEvents('dynamic_survey_details_theme', [
  'theme_modal_opened',
  'theme_created',
  'theme_updated',
  'theme_definition_generated',
  'theme_modal_closed',
  'theme_deleted',
]);
//tracking for interview details
export const INTERVIEW_DETAILS_EVENTS = createEvents('interview_details', [
  'interview_details_viewed',
  'response_insights_tab_clicked',
  'participant_data_tab_clicked',
  'transcripts_tab_clicked',
  'analyses_tab_clicked',
  'your_analysis_tab_clicked',
  'custom_reports_tab_clicked',
]);
